import { createContext, useContext, type ReactNode } from 'react';

export interface RouterAdapter {
  pathname: string;
  searchParams: URLSearchParams;
  push: (url: string) => void;
  replace: (url: string) => void;
  back: () => void;
}

const RouterAdapterContext = createContext<RouterAdapter | null>(null);

export function RouterAdapterProvider({
  adapter,
  children,
}: {
  adapter: RouterAdapter;
  children: ReactNode;
}) {
  return (
    <RouterAdapterContext.Provider value={adapter}>
      {children}
    </RouterAdapterContext.Provider>
  );
}

export function useRouterAdapter(): RouterAdapter {
  const ctx = useContext(RouterAdapterContext);
  if (!ctx) {
    throw new Error(
      'useRouterAdapter must be used within a RouterAdapterProvider',
    );
  }
  return ctx;
}
